import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import { useCallback, useState } from 'react';

import { useTranslate } from '../../../locales/use-locales';
import { Iconify } from '../../iconify/Iconify';

/**
 * Forces the browser to enter or exit full screen mode.
 */
export function FullScreenButton() {
    const { t } = useTranslate('settings');

    const [fullscreen, setFullscreen] = useState(false);

    const handleToggleFullscreen = useCallback(() => {
        if (!document.fullscreenElement) {
            document.documentElement.requestFullscreen();
            setFullscreen(true);
        } else if (document.exitFullscreen) {
            document.exitFullscreen();
            setFullscreen(false);
        }
    }, []);

    return (
        <Tooltip title={fullscreen ? t('exit') : t('fullscreen')}>
            <IconButton onClick={handleToggleFullscreen} color={fullscreen ? 'primary' : 'default'}>
                <Iconify
                    icon={
                        fullscreen
                            ? 'solar:quit-full-screen-square-outline'
                            : 'solar:full-screen-square-outline'
                    }
                />
            </IconButton>
        </Tooltip>
    );
}
